export default [
  {
    // 체육시설
    path: 'spfc',
    redirect: { name: 'DailyPaymentList' },
    children: [
      {
        // 마감관리
        path: 'daily-report-mng',
        redirect: { name: 'ClosingManage' },
        children: [
          // 전체
          {
            path: 'list',
            name: 'ClosingManage',
            meta: { menu: 'spfc', keepAlive: true },
            component: () => import('@/pages/reportMng/spfc/dailyReportMng/ClosingManageListView.vue')
          }
        ]
      },
      {
        // 일일 납입내역
        path: 'daily-payment-history',
        redirect: { name: 'DailyPaymentList' },
        children: [
          {
            path: 'list',
            name: 'DailyPaymentList',
            meta: { menu: 'spfc', keepAlive: true },
            component: () => import('@/pages/reportMng/spfc/DailyPaymentListView.vue')
          }
        ]
      },
      {
        // 결의서
        path: 'resolutions',
        redirect: { name: 'DailyResolutionList' },
        children: [
          {
            path: 'list',
            name: 'DailyResolutionList',
            meta: { menu: 'spfc', keepAlive: true },
            component: () => import('@/pages/reportMng/spfc/DailyResolutionListView.vue')
          }
        ]
      },
      {
        // 결제/환불 신청 현황
        path: 'payment-refund-status',
        redirect: { name: 'RequestStatusList' },
        children: [
          {
            path: 'list',
            name: 'RequestStatusList',
            meta: { menu: 'spfc', keepAlive: true },
            component: () => import('@/pages/reportMng/spfc/RequestStatusListView.vue')
          }
        ]
      },
      {
        // 일일상품 결제/환불 일보
        path: 'daily-product-payment',
        redirect: { name: 'DailyIncomePtFcltList' },
        children: [
          {
            path: 'list',
            name: 'DailyIncomePtFcltList',
            meta: { menu: 'spfc', keepAlive: true },
            component: () => import('@/pages/reportMng/spfc/DailyIncomePtFcltListView.vue')
          }
        ]
      },
      {
        // 일일 영업일보
        path: 'daily-sales-report',
        redirect: { name: 'DailySalesList' },
        children: [
          {
            path: 'list',
            name: 'DailySalesList',
            meta: { menu: 'spfc', keepAlive: true },
            component: () => import('@/pages/reportMng/spfc/DailySalesListView.vue')
          }
        ]
      },
      {
        // 품목(시설)별 영업일보
        path: 'item-sales-report',
        redirect: { name: 'DailyReportByPtFcltPrgRmList' },
        children: [
          {
            path: 'list',
            name: 'DailyReportByPtFcltPrgRmList',
            meta: { menu: 'spfc', keepAlive: true },
            component: () => import('@/pages/reportMng/spfc/DailyReportByPtFcltPrgRmListView.vue')
          }
        ]
      },
      {
        // 품목 구분별 영업일보
        path: 'item-type-sales-report',
        redirect: { name: 'DailyReportByPtFcltClsfList' },
        children: [
          {
            path: 'list',
            name: 'DailyReportByPtFcltClsfList',
            meta: { menu: 'spfc', keepAlive: true },
            component: () => import('@/pages/reportMng/spfc/DailyReportByPtFcltClsfListView.vue')
          }
        ]
      },
      {
        // 회원 영업일보
        path: 'member-sales-report',
        redirect: { name: 'MemberReportList' },
        children: [
          {
            path: 'list',
            name: 'MemberReportList',
            meta: { menu: 'spfc', keepAlive: true },
            component: () => import('@/pages/reportMng/spfc/MemberReportListView.vue')
          }
        ]
      },
      {
        // 환불 회원 현황
        path: 'refund-member-status',
        redirect: { name: 'MemberRequestStatusList' },
        children: [
          {
            path: 'list',
            name: 'MemberRequestStatusList',
            meta: { menu: 'spfc', keepAlive: true },
            component: () => import('@/pages/reportMng/spfc/MemberRequestStatusListView.vue')
          }
        ]
      },
      {
        // 카드 승인/취소 내역
        path: 'card-approval-history',
        redirect: { name: 'DssCardHistoryList' },
        children: [
          {
            path: 'list',
            name: 'DssCardHistoryList',
            meta: { menu: 'spfc', keepAlive: true },
            component: () => import('@/pages/reportMng/spfc/DssCardHistoryListView.vue')
          }
        ]
      },
      {
        // 매출 현황
        path: 'sales-status',
        redirect: { name: 'TotalSalesStatusList' },
        children: [
          {
            path: 'list',
            name: 'TotalSalesStatusList',
            meta: { menu: 'spfc', keepAlive: true },
            component: () => import('@/pages/reportMng/spfc/TotalSalesStatusListView.vue')
          }
        ]
      }
    ]
  }
]
